import { useRef, useEffect } from 'react'
import MarkdownMessage from '@gluedigital/markdown-message'
import CtaButton from '@components/CtaButton/CtaButton'
import featureSlides from './featureIndex'

import './FeatureCard.css'

export default function FeatureCard({
  dataId,
  revealed
}: {
  dataId: number
  revealed: boolean
}) {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (revealed && videoRef.current) {
      videoRef.current.play()
    }
  }, [revealed])

  return (
    <article
      id={`feature-card-${dataId}`}
      className={`split feature-card ${revealed ? 'revealed' : ''}`}
    >
      <div className="item item-left">
        <h2>
          <MarkdownMessage id={`feature-card.data-id-${dataId}.title`} />
        </h2>
        <p>
          <MarkdownMessage id={`feature-card.data-id-${dataId}.text`} />
        </p>
        <CtaButton filled={true} />
      </div>

      <div className="item item-right">
        <video
          ref={videoRef}
          muted
          playsInline
          poster={featureSlides['slide-' + dataId].poster}
        >
          <source
            src={featureSlides['slide-' + dataId].video}
            type="video/webm"
          />
          <img src={featureSlides['slide-' + dataId].poster} alt="" />
        </video>
      </div>
    </article>
  )
}
